import styled from '@emotion/styled'

export const AttachmentTileNewWrapper = styled.div`
  aspect-ratio: 1 / 1.41;
`
